"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFanProInputType = parseFanProInputType;
const GraphQLTypes = __importStar(require("@genesys/graphql-types-tools"));
const property_1 = require("@genesys/property");
const calculations_1 = require("@munters/calculations");
const KnownProperties = __importStar(require("./known-properties"));
function parseFanProInputType(pvs, fanCurvePoints) {
    const temperatureIn = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsTemperature, pvs);
    const pressureIn = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsPressure, pvs);
    const relativeHumidity = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsHumidity, pvs);
    const humidityIn = calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureIn, temperatureIn, relativeHumidity);
    const flow = property_1.PropertyValueSet.getAmount(KnownProperties.airInputsMassflow, pvs);
    return {
        fanDefinition: parseFanProFanDefinitionType(pvs, fanCurvePoints),
        fanOperationalRange: parseFanProFanOperationalRangeInputType(pvs),
        motorDefinition: parseFanProMotorDefinitionInputType(pvs),
        temperatureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(temperatureIn)),
        humidityIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(humidityIn)),
        pressureIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(pressureIn)),
        flowIn: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(flow)),
        actualDensity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.actualDensity, pvs)),
        fanQuantity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanQuantity, pvs)),
        controlMode: parseControlMode(property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanControlMode, pvs))),
        targetPressure: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.targetPressure, pvs))
    };
}
function parseControlMode(value) {
    if (value === "1") {
        return GraphQLTypes.FanProControlMode.MODULATE;
    }
    if (value === "2") {
        return GraphQLTypes.FanProControlMode.MAXIMIZE;
    }
    throw new Error(`Invalid ControlMode: ${value}`);
}
function parseFanProFanDefinitionType(pvs, fanCurvePoints) {
    return {
        definitionSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanDefinitionSpeed, pvs)),
        definitionStandardDensity: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanDefinitionStandardDensity, pvs)),
        performanceModel: parseFanProPerformanceModelInputType(pvs, fanCurvePoints)
    };
}
function parseFanProPerformanceModelInputType(pvs, fanCurvePoints) {
    const fanCurveRows = fanCurvePoints.map((p) => parseFanCurveRow(p));
    return {
        fanCurveRows: fanCurveRows,
        outletArea: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanOutletArea, pvs)),
        dynamicPressureLossCoefficient: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanDynamicPressureLossCoefficient, pvs))
    };
}
function parseFanProMotorDefinitionInputType(pvs) {
    return {
        inputPower: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorInputPower, pvs)),
        cosPhi: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorCosphi, pvs)),
        motorPoles: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorPoles, pvs)),
        gridPowerExponent: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorGridPowerExponent, pvs)),
        phases: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorPhases, pvs)),
        voltage: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.motorVoltage, pvs))
    };
}
function parseFanProFanOperationalRangeInputType(pvs) {
    return {
        minimumSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanMinimumSpeed, pvs)),
        maximumSpeed: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.fanMaximumSpeed, pvs))
    };
}
function parseFanCurveRow(pvs) {
    return {
        airFlow: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.airFlow, pvs)),
        pressure: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.pressure, pvs)),
        shaftPower: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.shaftPower, pvs)),
        gridPower: property_1.PropertyValue.toString(property_1.PropertyValueSet.get(KnownProperties.gridPower, pvs))
    };
}
//# sourceMappingURL=input-parser.js.map